/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EnquadramentoTitularCriteriaDto } from '../models/enquadramento-titular-criteria-dto';
import { EnquadramentoTitularDto } from '../models/enquadramento-titular-dto';
import { EnquadramentoTitularFormDto } from '../models/enquadramento-titular-form-dto';
import { EnquadramentoTitularPageDto } from '../models/enquadramento-titular-page-dto';


/**
 * Enquadramentos Entidade Titular
 */
@Injectable({
  providedIn: 'root',
})
export class EnquadramentoTitularService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getEnquadramentosTitular
   */
  static readonly GetEnquadramentosTitularPath = '/enquadramentos-titular';

  /**
   * Pesquisar Titulares de Fontes de Radiação.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnquadramentosTitular()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentosTitular$Response(params?: {
    criteria?: EnquadramentoTitularCriteriaDto;
  }): Observable<StrictHttpResponse<EnquadramentoTitularPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, EnquadramentoTitularService.GetEnquadramentosTitularPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnquadramentoTitularPageDto>;
      })
    );
  }

  /**
   * Pesquisar Titulares de Fontes de Radiação.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEnquadramentosTitular$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentosTitular(params?: {
    criteria?: EnquadramentoTitularCriteriaDto;
  }): Observable<EnquadramentoTitularPageDto> {

    return this.getEnquadramentosTitular$Response(params).pipe(
      map((r: StrictHttpResponse<EnquadramentoTitularPageDto>) => r.body as EnquadramentoTitularPageDto)
    );
  }

  /**
   * Path part for operation submeterEnquadramentoTitular
   */
  static readonly SubmeterEnquadramentoTitularPath = '/enquadramentos-titular';

  /**
   * Submeter um pedido de Enquadramento de Entidade Titular.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submeterEnquadramentoTitular()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterEnquadramentoTitular$Response(params?: {
    body?: EnquadramentoTitularFormDto
  }): Observable<StrictHttpResponse<EnquadramentoTitularDto>> {

    const rb = new RequestBuilder(this.rootUrl, EnquadramentoTitularService.SubmeterEnquadramentoTitularPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnquadramentoTitularDto>;
      })
    );
  }

  /**
   * Submeter um pedido de Enquadramento de Entidade Titular.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submeterEnquadramentoTitular$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submeterEnquadramentoTitular(params?: {
    body?: EnquadramentoTitularFormDto
  }): Observable<EnquadramentoTitularDto> {

    return this.submeterEnquadramentoTitular$Response(params).pipe(
      map((r: StrictHttpResponse<EnquadramentoTitularDto>) => r.body as EnquadramentoTitularDto)
    );
  }

  /**
   * Path part for operation getEnquadramentoTitular
   */
  static readonly GetEnquadramentoTitularPath = '/enquadramentos-titular/{id}';

  /**
   * Pesquisar Titulares de Fontes de Radiação por Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEnquadramentoTitular()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentoTitular$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<EnquadramentoTitularDto>> {

    const rb = new RequestBuilder(this.rootUrl, EnquadramentoTitularService.GetEnquadramentoTitularPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnquadramentoTitularDto>;
      })
    );
  }

  /**
   * Pesquisar Titulares de Fontes de Radiação por Id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEnquadramentoTitular$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEnquadramentoTitular(params: {
    id: number;
  }): Observable<EnquadramentoTitularDto> {

    return this.getEnquadramentoTitular$Response(params).pipe(
      map((r: StrictHttpResponse<EnquadramentoTitularDto>) => r.body as EnquadramentoTitularDto)
    );
  }

}
